import React, { useRef, useEffect } from 'react';
import Helmet from 'react-helmet';
import { useTranslate } from '../contexts/languageContext';
import { Layout, CajaDch } from '../containers/Layout';
import { useIsDesktopReal } from '../hooks/useMediaQuery';
import ConsolidadoStats from '../containers/ConsolidadoStats';
import RankingStats from '../containers/RankingStats';
import CheckboxList from '../components/CheckboxList/index';
import FooterLayout from '../components/Footer/Footer';
import HeaderTitle from '../components/Headers/HeaderTitle/index';
import { usePage } from '../contexts/pageContext';
import styled from 'styled-components/macro';
import { responsive } from '../resources/constantes.json';
import DropdownSelectorPropiedades from '../containers/DropdownSelectorPropiedades';
import Header from '../containers/Header';
import { getColorOfElec } from '../commons/js/util';
import Logo from '../assets/img/COBRANDING_ELECCIONES_2023-08.png';
import { useMesa } from '../contexts/viewContext';

/**
 * Página que muestra estadísticas para cada elección
 */

const Estadisticas = props => {
  const t = useTranslate();
  const isDesktop = useIsDesktopReal();
  const { setMesa } = useMesa();
  const pageState = usePage();
  const nomenclator = props.nomenclator;
  const { data, urlInfo } = pageState;
  const {
    page,
    elec,
    tipoEst,
    tipoDato,
    tipoEst2,
    tipoDato2,
    setTipoEst,
    setTipoDato,
    setTipoEst2,
    setTipoDato2,
  } = urlInfo;

  const consts = {
    titulo: t('tipoEstadistica'),
    color: '#283f5f',
    lista: [
      {
        titulo: t('ranking'),
        tipo: 'R',
        lista: [
          { tipo: 'PA', nombre: t('tipoDato-PA') },
          { tipo: 'AB', nombre: t('tipoDato-AB') },
          { tipo: 'VV', nombre: t('tipoDato-VV') },
          { tipo: 'VB', nombre: t('tipoDato-VB') },
          { tipo: 'VN', nombre: t('tipoDato-VN') },
          { tipo: 'NM', nombre: t('tipoDato-NM') },
          { tipo: 'VP', nombre: t('tipoDato-VP') },
        ],
      },
    ],
  };

  const consts2 = {
    titulo: t('tipoEstadistica'),
    color: '#283f5f',
    lista: [
      {
        titulo: t('consolidado'),
        tipo: 'C',
        lista: [
          { tipo: 'VT', nombre: t('tipoDato-VT') },
          { tipo: 'AB', nombre: t('tipoDato-AB') },
          { tipo: 'VV', nombre: t('tipoDato-VV') },
          { tipo: 'VB', nombre: t('tipoDato-VB') },
          { tipo: 'VN', nombre: t('tipoDato-VN') },
          { tipo: 'NM', nombre: t('tipoDato-NM') },
        ],
      },
    ],
  };

  const vars = {
    vars: [tipoEst, tipoDato],
    funs: [
      params => {
        setTipoEst(params);
      },
      params => {
        setTipoDato(params);
      },
    ],
  };

  const vars2 = {
    vars: [tipoEst2, tipoDato2],
    funs: [
      params => {
        setTipoEst2(params);
      },
      params => {
        setTipoDato2(params);
      },
    ],
  };

  const widthRight = '370px';
  const widthLeft = `calc(100% - ${widthRight})`;
  const colorElec = getColorOfElec(page, nomenclator);
  const nomAmbitos = nomenclator.nomAmbitos[elec];
  const tablaRef = useRef(null);

  const onDataChange = () => {
    if (tablaRef.current) {
      tablaRef.current.scrollTop = 0;
    }
  };

  // Utiliza useEffect para controlar los cambios en los datos
  useEffect(() => {
    if (data) {
      onDataChange();
      setMesa(null);
    }
  }, [data, setMesa]);

  return (
    <>
      <Helmet>
        <title itemProp="name" lang="es">
          Estadísticas | Elecciones Territoriales 2023
        </title>
      </Helmet>
      <Layout>
        {!isDesktop && (
          <Header
            page={page}
            variant={'estadisticas'}
            nomenclator={nomenclator}
            eleccion={elec}
            ambito={nomenclator.ambitos[1][0]}
            data={data}
          />
        )}

        <EstadisticasLayout>
          {isDesktop && (
            <HeaderDesktopContainer>
              <ContenedorLogos>
                <img
                  src={Logo}
                  alt={'Logos'}
                  style={{ padding: '0px', height: '100%' }}
                />
              </ContenedorLogos>
              <HeaderTitle
                title={nomAmbitos.n}
                subtitle={'ESTADÍSTICAS'}
                color={colorElec}
                marginBottom={'unset'}
                withColorBar={false}
              />
            </HeaderDesktopContainer>
          )}
          <EstadisticaSectionsContainer>
            <Section>
              <SectionTitle>{t('ranking')}</SectionTitle>
              <RoundSection>
                <DropdownSelectorPropiedadesContainer>
                  <DropdownSelectorPropiedades
                    atts={consts}
                    vars={vars}
                    elec={elec}
                  />
                </DropdownSelectorPropiedadesContainer>
                <RoundLayout>
                  <CajaIzqCustom width={widthLeft}>
                    {data && (
                      <>
                        <ContainerTabla ref={tablaRef}>
                          <RankingStats
                            tipo={tipoDato}
                            elec={elec}
                            data={data[0]}
                            nomenclator={props.nomenclator}
                          />
                        </ContainerTabla>
                      </>
                    )}
                  </CajaIzqCustom>
                  <CajaDchContainer>
                    <CajaDch width={widthRight}>
                      <CheckboxList atts={consts} vars={vars} elec={elec} />
                    </CajaDch>
                  </CajaDchContainer>
                </RoundLayout>
              </RoundSection>
            </Section>
            <Section>
              <SectionTitle>{t('consolidadoNacional')}</SectionTitle>
              <RoundSection>
                <DropdownSelectorPropiedadesContainer>
                  <DropdownSelectorPropiedades
                    atts={consts2}
                    vars={vars2}
                    elec={elec}
                  />
                </DropdownSelectorPropiedadesContainer>
                <RoundLayout>
                  <CajaIzqCustom width={widthLeft}>
                    {data && (
                      <>
                        <ConsolidadoStats
                          isDesktop={isDesktop}
                          tipo={tipoDato}
                          data={data[1]}
                        />
                      </>
                    )}
                  </CajaIzqCustom>
                  <CajaDchContainer>
                    <CajaDch width={widthRight} page={page} tipoEst={tipoEst}>
                      <CheckboxList atts={consts2} vars={vars2} elec={elec} />
                    </CajaDch>
                  </CajaDchContainer>
                </RoundLayout>
              </RoundSection>
            </Section>
          </EstadisticaSectionsContainer>
        </EstadisticasLayout>
        {data && <FooterLayout />}
      </Layout>
    </>
  );
};

const EstadisticasLayout = styled.div`
  background: white;
  padding: 0rem 4rem 0px 10rem;
  color: #164192;
  @media (max-width: ${responsive.maxWidth.desktop}px) {
    padding: 0rem 4rem 0px 4rem;
  }

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    padding: 3rem 3rem 0px 3em;
  }

  @media (max-width: ${responsive.maxWidth.mobile}px) {
    padding: 1.8rem 1.8rem 0px 1.8rem;
  }
`;

const HeaderDesktopContainer = styled.div`
  margin-bottom: 3rem;
`;

const ContenedorLogos = styled.div`
  height: 100px;

  @media (max-width: ${responsive.maxWidth.desktop}px) {
    height: 80px;
  }
`;

const ContainerTabla = styled.div`
  max-height: 580px;
  overflow: auto;

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    max-height: unset;
  }
`;

const DropdownSelectorPropiedadesContainer = styled.div`
  display: none;
  @media (max-width: ${1365}px) {
    display: block;
  }
`;

const CajaDchContainer = styled.div`
  @media (max-width: ${1365}px) {
    display: none;
  }
`;

const CajaIzqCustom = styled.section`
  display: flex;
  flex-flow: column nowrap;
  width: ${({ width }) => width};
  @media (max-width: ${1365}px) {
    width: 100%;
  }
`;

const EstadisticaSectionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4.7rem;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const SectionTitle = styled.h3`
  font-size: 2.4rem;
  font-weight: 500;
`;

const RoundSection = styled.div`
  border-radius: 25px;
  background: #f9fafe;
  overflow: hidden;
  padding: 2rem;
`;

const RoundLayout = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  margin: auto;

  @media (max-width: ${1365}px) {
    flex-direction: column;
  }
`;

export default Estadisticas;
